"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flatListToTrees = exports.notEmpty = void 0;
/**
 * Type Guard function for filtering empty values out of arrays.
 *
 * Usage: arr.filter(notEmpty)
 */

function notEmpty(value) {
  return value !== null && value !== undefined;
}

exports.notEmpty = notEmpty;
/**
 * Generate hierarchical tree data structure from flat node list with parent id
 */

function flatListToTrees(data, options) {
  if (!data) {
    return [];
  } // wrap nodes to the tree interface


  var trees = data.filter(notEmpty).map(function (node) {
    return {
      node: node,
      children: []
    };
  }); // tree roots ie. pages without parent

  var treeRoots = trees.filter(function (tree) {
    return !options.getParentId(tree.node);
  });

  for (var _i = 0, trees_1 = trees; _i < trees_1.length; _i++) {
    var child = trees_1[_i];

    if (!options.getParentId(child.node)) {
      continue;
    }

    for (var _a = 0, trees_2 = trees; _a < trees_2.length; _a++) {
      var parent_1 = trees_2[_a];

      if (options.getId(parent_1.node) && options.getParentId(child.node) && options.getId(parent_1.node) === options.getParentId(child.node)) {
        parent_1.children.push(child);
      }
    }
  }

  return treeRoots;
}

exports.flatListToTrees = flatListToTrees;